<template>
    <div class="m-portlet" style="-webkit-box-shadow: none; box-shadow: none;" @click="toggleTableView(null)">
        <div class="m-portlet__head" style="border-bottom: none;">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title" @click="toggleFilterBlock">
                    <span class="m-portlet__head-icon"><i :class="filterIcon"></i></span>
                    <h6 class="m-portlet__head-text">{{ labels.filters }}</h6>
                </div>
            </div>
        </div>
        <!--begin::Form-->
        <form id="filters-block" class="m-form m-form--fit m-form--label-align-right m-form--group" style="background-color: #f7f8fa; border-color: #f7f8fa; margin: 0 30px;" v-show="showFilters">
            <div class="m-portlet__body">
                <div class="form-group m-form__group row">
                    <div class="col-lg-6">
                        <label>{{ labels.resources.collections }} :</label>
                        <select
                                id="collectionName"
                                class="form-control m-choices-multiple"
                                title="Choose one of the following..."
                                v-model="filters.collectionName"
                                multiple
                                @change="filterSelected('collectionName')"></select>
                    </div>
                    <div class="col-lg-6">
                        <label class="">{{ labels.resources.brands }} :</label>
                        <select
                                id="brandName"
                                class="form-control m-choices-multiple"
                                title="Choose one of the following..."
                                v-model="filters.brandName"
                                multiple
                                @change="filterSelected('brandName')"></select>
                    </div>
                </div>

                <div class="form-group m-form__group row">
                    <div class="col-lg-6">
                        <label class="">{{ labels.resources.package_capacities }} :</label>
                        <select
                                id="packageCapacityId"
                                class="form-control m-choices-multiple"
                                title="Choose one of the following..."
                                v-model="filters.packageCapacityId"
                                multiple
                                @change="filterSelected('packageCapacityId')"></select>
                    </div>
                    <div class="col-lg-6">
                        <label class="">{{ labels.source }} :</label>
                        <select
                                id="source"
                                class="form-control m-choices-multiple"
                                title="Choose one of the following..."
                                v-model="filters.source"
                                multiple
                                @change="filterSelected('source')"></select>
                    </div>
                </div>
                <div class="form-group m-form__group row">
                    <div class="col-lg-6">
                        <label class="">{{ labels.alert_status }} :</label>
                        <div class="m-radio-inline">
                            <label class="m-radio m-radio--solid" for="expired">
                                <input id="expired" v-model="filters.status" type="radio" name="expired" value="expired" @click="updateFilter('status', ['expiring_soon', 'ok'], 'expired')"> {{ labels.expired }} ({{ booleanResultsValue(facets.status ? facets.status.expired : '') }})
                                <span></span>
                            </label>
                            <label class="m-radio m-radio--solid" for="expiring_soon">
                                <input id="expiring_soon" v-model="filters.status" type="radio" name="expiring_soon" value="expiring_soon" @click="updateFilter('status', ['expired', 'ok'], 'expiring_soon')"> {{ labels.expiring_soon }} ({{ booleanResultsValue(facets.status ? facets.status.expiring_soon : '') }})
                                <span></span>
                            </label>
                            <label class="m-radio m-radio--solid" for="ok">
                                <input id="ok" type="radio" v-model="filters.status" name="ok" value="ok" @click="updateFilter('status', ['expired', 'expiring_soon'], 'ok')"> {{ labels.ok }} ({{ booleanResultsValue(facets.status ? facets.status.ok : '') }})
                                <span></span>
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <label class="">{{ labels.open }} :</label>
                        <div class="m-radio-inline">
                            <label class="m-radio m-radio--solid" for="is_open_yes">
                                <input id="is_open_yes" v-model="filters.isOpened" type="radio" name="is_open_yes" value="true" @click="updateFilter('isOpened', ['is_open_no'], 'is_open_yes')"> {{ labels.yes }} ({{ booleanResultsValue(facets.isOpened ? facets.isOpened.true : '') }})
                                <span></span>
                            </label>
                            <label class="m-radio m-radio--solid" for="is_open_no">
                                <input id="is_open_no" v-model="filters.isOpened" type="radio" name="is_open_no" value="false" @click="updateFilter('isOpened', ['is_open_yes'], 'is_open_no')"> {{ labels.no }} ({{ booleanResultsValue(facets.isOpened ? facets.isOpened.false : '') }})
                                <span></span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="form-group m-form__group row">
                    <div class="col-lg-6">
                        <label class="">{{ labels.loan }} :</label>
                        <div class="m-radio-inline">
                            <label class="m-radio m-radio--solid" for="is_loan_yes">
                                <input v-model="filters.isLoaned" id="is_loan_yes" type="radio" name="is_loan_yes" @click="updateFilter('isLoaned', ['is_loan_no'], 'is_loan_yes')" value="true"> {{ labels.yes }} ({{ booleanResultsValue(facets.isLoaned ? facets.isLoaned.true : '') }})
                                <span></span>
                            </label>
                            <label class="m-radio m-radio--solid" for="is_loan_no">
                                <input v-model="filters.isLoaned" id="is_loan_no" type="radio" name="is_loan_no" @click="updateFilter('isLoaned', ['is_loan_yes'], 'is_loan_no')" value="false"> {{ labels.no }} ({{ booleanResultsValue(facets.isLoaned ? facets.isLoaned.false : '') }})
                                <span></span>
                            </label>
                        </div>
                    </div>
                    <!-- <div class="col-lg-2"></div> -->
                </div>
            </div>
            <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                    <div class="row">
                        <div class="col-lg-5"></div>
                        <div class="col-lg-1" >
                            <button :disabled="disableReset" :class="{'disabled': disableReset}" type="reset" class="btn btn-primary" @click="resetFilters">{{ labels['clear_filters'] }}</button>
                        </div>
                        <div class="col-lg-5"></div>
                    </div>
                </div>
            </div>
        </form>
        <!--end::Form-->
        <!-- <results-alert></results-alert> -->
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Choices from 'choices.js';

export default {
  name: 'Filters',
  props: ['firstSearch'],
  data() {
    return {
      filters: {
        collectionName: [],
        brandName: [],
        status: '',
        isLoaned: null,
        isOpened: null,
        availableCIP: null,
        packageCapacityId: [],
        source: [],
      },
      showFilters: true,
      refreshSearch: true,
      lastSelectedFacet: '',
    };
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      facetFilters: (store) => store.stocks.facetFilters,
      keywords: (store) => store.stocks.keywords,
      facets: (store) => store.stocks.results.facets,
      totalRecords: (store) => store.stocks.results.totalRecords,
      defaultFacets: (store) => store.stocks.defaultFacets,
    }),
    ...mapGetters([
      'getName',
    ]),
    disableReset() {
      return !this.activeFilters.length && this.keywords.trim().length < 1;
    },
    filterIcon() {
      return this.showFilters ? 'fa fa-angle-up' : 'fa fa-angle-down';
    },
    activeFilters() {
      const facetFilters = [];
      // Loop through each filter to retrieve values
      // Join each attribute with 'AND'
      // Within array join each value with 'OR'
      for (const key in this.filters) {
        if (this.filters[key] && this.filters[key].length) {
          const data = {
            name: key,
            value: this.filters[key],
          };
          if (Array.isArray(data.value)) {
            var arrayFilters = [];
            var filterName = `${data.name}:`;
            // var arrayFilters = '('
            data.value.forEach((val) => {
              const string = (filterName + val);
              arrayFilters.push(string);
            });
            facetFilters.push(arrayFilters);
          } else {
            const singleFilter = [(`${data.name}:${data.value}`)];
            facetFilters.push(singleFilter);
          }
        }
      }
      return facetFilters;
    },
  },
  watch: {
    facetFilters() {
      if (this.firstSearch) {
        // Resend algolia request on each facetFilters change
        this.searchStocks();
      }
    },
    'facets.brandName': function () {
      this.manageChoices('brandName', 'brandNameChoices');
    },
    'facets.collectionName': function () {
      this.manageChoices('collectionName', 'collectionNameChoices');
    },
    'facets.packageCapacityId': function () {
      this.manageChoices('packageCapacityId', 'packageCapacityIdChoices');
    },
    'facets.source': function () {
      this.manageChoices('source', 'sourceChoices');
    },
  },
  methods: {
    ...mapActions([
      'searchStocks',
      'toggleTableView',
      'updateFacetFilters',
      'updateKeyword',
    ]),
    booleanResultsValue(filter) {
      return filter || 0;
    },
    initialiseChoices() {
      // this.resetFilters();
      const my = this;
      $('#filters-block .m-choices-multiple').each(function () {
        const element = this;
        const elementId = $(this).attr('id');
        my[`${elementId}Choices`] = new Choices(element, {
          searchChoices: true,
          removeItems: true,
          removeItemButton: true,
          shouldSort: false,
        });
      });
    },
    toggleFilterBlock() {
      this.showFilters = !this.showFilters;
    },
    resetFilters() {
      this.filters = {
        collectionName: [],
        brandName: [],
        status: '',
        isLoaned: null,
        isOpened: null,
        packageCapacityId: [],
        source: [],
      };
      this.updateKeyword('');
      this.updateFacetFilters([]);
    },
    filterSelected(source) {
      this.lastSelectedFacet = source;
      this.updateFacetFilters(this.activeFilters);
    },
    manageChoices(field, choiceName) {
      const choices = [];
      const list = this.defaultFacets[field] ? Object.keys(this.defaultFacets[field]) : [];
      list.map((data) => {
        if (field === 'packageCapacityId') {
          const choice = {
            value: data,
            label: this.getName(data, 'package_capacity_id', 'package_capacities'),
            selected: this.checkChoiceSelected(field, data),
          };
          choices.push(choice);
        } else {
          const choice = {
            value: data,
            label: data,
            selected: this.checkChoiceSelected(field, data),
          };
          choices.push(choice);
        }
      });
      this[choiceName] && !this[choiceName]._currentState.choices.length ? this[choiceName].setChoices(choices, 'value', 'label', true) : null;
      return choices;
    },
    initSelected(field, data) {
      return !!this.facetFilters.find((facet) => {
        facet.forEach((item) => {
          const values = item.split(':');
          if (this.filters.hasOwnProperty(values[0])) {
            if (Array.isArray(this.filters[values[0]])) {
              this.filters[values[0]].push(values[1]);
            } else {
              this.filters[values[0]] = values[1];
            }
          }
        });
        if (facet.includes(`${field}:${data}`)) {
          return true;
        }
        return false;
      });
    },
    checkChoiceSelected(field, data) {
      return !!this.facetFilters.find((facet) => {
        if (facet.includes(`${field}:${data}`)) {
          return true;
        }
        return false;
      });
    },
    updateFilter(filter, siblings, selector) {
      if (this.filters[filter] === event.target.value) {
        this.filters[filter] = null;
        $(`#${selector}`).prop('checked', false);
      } else {
        this.filters[filter] = event.target.value;
      }
      if (siblings) {
        // Deselect the checkbox
        siblings.forEach((sibling) => {
          $(`#${sibling}`).prop('checked', false);
        });
      }
      this.filterSelected(filter);
    },
  },
  mounted() {
    this.initSelected();
    this.initialiseChoices();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Stocks/Filters.vue